import Api from './Api';

class MonitoringGraphApi extends Api {
  constructor(baseUrl: string, headers: any) {
    super(baseUrl, '/MonitoringGraph', headers);
  }

  get = (botId: string, payload: any) => this.instance.get(`/${botId}`, {
    params: {
     ...payload,
    },
  });

  getPath= (botId: string, payload: any) => this.instance.get(`/${botId}/Path`, {
    params: {
      ...payload,
    }
  });

  getFilter = (botId: string) => this.instance.get(`/Filters/${botId}`);
}

export default MonitoringGraphApi;

